<template>
  <div>
    <h1 class="yazio-header-title font-normal sm:text-32 sm:text-left text-lg text-center">
      Onedio Köşe Yazarları
      <strong>Yazio</strong>
    </h1>
    <div class="max-w-[750px] sm:text-md sm:mt-4 sm:text-left mt-2 text-xs text-center">
      <p>
        Her konu hakkında her kafadan bir sesin çıktığı internet dünyasında hangi fikirlerin dikkate değer olduğunu belirlemende sana yardım
        etmek istedik ve bu platformu oluşturduk.
      </p>
      <div v-if="!hideDetails">
        <br />
        <p>
          Burada yazarların içeriklerinde kimi zaman kendini bulacaksın, kimi zaman verdikleri bilgilerle ufkun genişleyecek, kimi zaman
          fikirleriyle bakış açın değişecek. Yorumlarında fikirlerine hak verecek veya karşıt fikrini söyleyebileceksin.
        </p>
      </div>
      <div v-else style="color: #c6bedf">
        <br />
        <p @click="showDetails = true">Daha fazla...</p>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, computed } from '@nuxtjs/composition-api';
import { useDevice } from '~/composables/useDevice';

export default defineComponent({
  setup() {
    const { isMobile } = useDevice();
    const showDetails = ref(false);
    const hideDetails = computed(() => isMobile.value && !showDetails.value);
    return { showDetails, hideDetails };
  },
});
</script>
<style lang="scss" scoped>
.yazio-header-title {
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
}
</style>
